import React, { useEffect, useReducer } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import { BASE_URL } from './api/api';

import './App.scss';

// import pages 
import Home from './pages/Home';
import CreateChannel from './pages/CreateChannel';
import Profile from './pages/Profile';
import Browse from './pages/Browse';

// import components 
import Header from './components/Header';
import ContentUploaderForm from './components/ContentUploaderForm';
import TabAdder from './components/TabAdder';
import SignUp from './components/SignUp';

// import Context 
import { ContentUploaderFormDisplay } from './context/ContentUploaderDisplay';
import { TabAdderDisplay } from './context/TabAdderDisplay';
import { EditTabNameDisplay } from './context/EditTabNameDisplay';
import { TabData } from './context/TabData';
import { UpdatePost } from './context/UpdatePostAfterUploading';
import { Auth } from './context/Auth';

// importing Reducers 
import { showContentUploaderForm, ShowContentUploaderFormReducer } from './reducers/ContentUploaderDisplay';
import { showTabAdderForm, ShowTabAdderFormReducer } from './reducers/TabAdderDisplay';
import { showEditTabNameForm, ShowEditTabNameFormReducer } from './reducers/EditTabNameDisplay';
import { tabData, TabDataReducer } from './reducers/TabData';
import { auth, AuthReducer } from './reducers/Auth';
import { updatePost, UpdatePostReducer } from './reducers/UpdatePostAfterUploading';

import Login from './components/Login';
import Chat from './pages/Chat';
import Explore from './pages/Explore';
import Recent from './pages/Recent';
import ImageToPdf from './pages/ImageToPdf';
import PptxToPdf from './pages/PptToPdf';
import ManageAccount from './pages/ManageAccount';
import Password from './components/ManageAccount/Password';
import EditTabName from './components/EditTabName';
import MyChannel from './pages/MyChannel';
import HiddenComponent from './components/HiddenComponent';

function App() {
  const [displayContentUploaderForm, showContentUploaderFormDispatch] = useReducer(ShowContentUploaderFormReducer, showContentUploaderForm);

  const [displayTabAdderForm, showTabAdderFormDispatch] = useReducer(ShowTabAdderFormReducer, showTabAdderForm);

  const [displayEditTabNameForm, showEditTabNameFormDispatch] = useReducer(ShowEditTabNameFormReducer, showEditTabNameForm);

  const [updatedTabData, tabDataReducerDispatch] = useReducer(TabDataReducer, tabData);
  const [updatedAuth, authReducerDispatch] = useReducer(AuthReducer, auth);
  const [updatedPost, UpdatePostDispatch] = useReducer(UpdatePostReducer, updatePost);

  const [cookies, setCookie] = useCookies(['token', 'userId', 'isLoggedIn', 'channelId']);


  // Setting default active tab, to aviod error
  // window.sessionStorage.setItem("activeTabDetail", JSON.stringify({ id: "null" }))

  // useEffect(() => {
  //   axios.post(`${BASE_URL}/api/auth/fetch-user-details`, { userId: cookies.userId })
  //     .then(res => {
  //       console.log(res, "fetch User in App.js");
  //       if (res.data.statusText === "success") {
  //         if (res.data.user.channelId) {
  //           auth.authReducerDispatch({ type: "updateChannelId", payload: { channelId: res.data.user.channelId } });
  //         }
  //       }
  //     })
  //     .catch(err => console.log(err))

  // }, [cookies.userId])

  return (
    <>
      <BrowserRouter>
        <ContentUploaderFormDisplay.Provider value={{ displayContentUploaderFormState: displayContentUploaderForm, showContentUploaderFormDispatch: showContentUploaderFormDispatch }}>

          <TabAdderDisplay.Provider value={{ displayTabAdderFormState: displayTabAdderForm, showTabAdderFormDispatch: showTabAdderFormDispatch }}>

            <EditTabNameDisplay.Provider value={{ displayEditTabNameState: displayEditTabNameForm, showEditTabNameFormDispatch: showEditTabNameFormDispatch }}>

              <TabData.Provider value={{ updatedTabDataState: updatedTabData, tabDataReducerDispatch: tabDataReducerDispatch }}>

                <Auth.Provider value={{ authState: updatedAuth, authReducerDispatch: authReducerDispatch }}>

                  <UpdatePost.Provider value={{ updatedPostState: updatedPost, updatePostDispatch: UpdatePostDispatch }}>

                    {
                      cookies.isLoggedIn && <HiddenComponent />
                    }

                    <Routes>
                      <Route exact path="/sign-up" element={<SignUp />} />
                      <Route exact path="/login" element={<Login />} />
                      <Route exact path="/" element={<><Header /><Home /></>} />
                      <Route exact path="/create-channel" element={<><Header /><CreateChannel /></>} />
                      <Route path="/profile/:channelHandle" element={<><Header /><Profile /></>} />

                      {/* <Route exact path="/browse" element={<><Header /><BrowseContent content={JSON.parse(window.sessionStorage.getItem("contentToView"))} /></>} /> */}
                      <Route exact path="/browse" element={<><Header /><Browse /></>} />
                      <Route exact path="/recent" element={<><Header /><Recent /></>} />
                      <Route exact path="/explore" element={<><Header /><Explore /></>} />
                      <Route exact path="/chat" element={<Chat />} />
                      <Route exact path="/img-to-pdf" element={<><Header /><ImageToPdf /></>} />
                      <Route exact path="/ppt-to-pdf" element={<PptxToPdf />} />

                      <Route path="/my-channel/:channelHandle" element={<><Header /><MyChannel /></>} />

                      {/* Manage Account Routes  */}
                      <Route exact path="/manage-account" element={<><Header /><ManageAccount formToDisplay="profileEdit" /></>} />
                      <Route exact path="/update-profile" element={<><Header /><ManageAccount formToDisplay="profileEdit" /></>} />
                      <Route exact path="/edit-password" element={<><Header /><ManageAccount formToDisplay="passwordEdit" /></>} />
                    </Routes>

                    {/* Forms to display */}
                    {displayContentUploaderForm && <ContentUploaderForm />}
                    {displayTabAdderForm === true && <TabAdder />}
                    {displayEditTabNameForm && <EditTabName />}


                  </UpdatePost.Provider>
                </Auth.Provider>
              </TabData.Provider>
            </EditTabNameDisplay.Provider>
          </TabAdderDisplay.Provider>
        </ContentUploaderFormDisplay.Provider>
      </BrowserRouter >
      <ToastContainer closeOnClick />
    </>
  );
}

export default App;
